import { Image } from "../../../../../AbstractElements";
import { dynamicImage } from "../../../../../Utils";
import { Email, Phone, Website } from "../../../../../Utils/Constants";

const InvoiceRightLogo = () => {
  return (
    <td>
      <Image className="img-fluid" src={dynamicImage("logo/logo.png")} alt="logo" style={{ marginBottom: 14 }} />
      <span style={{ display: "block", lineHeight: "1.5", fontSize: 16, fontWeight: 400, opacity: "0.8" }} >
        2118 Thornridge Cir. Syracuse, Connecticut 35624, United State
      </span>
      <span style={{ display: "block", lineHeight: "1.5", fontSize: 16, fontWeight: 400, opacity: "0.8" }} >
        {Phone} : (239) 555-0108
      </span>
      <span style={{ display: "block", lineHeight: "1.5", fontSize: 16, fontWeight: 400, opacity: "0.8" }} >
        {Email} : Lagos@themesforest.com
      </span>
      <span style={{ display: "block", lineHeight: "1.5", fontSize: 16, fontWeight: 400, opacity: "0.8"}}>
        {Website}: www.Lagosthemes.com
      </span>
    </td>
  );
};

export default InvoiceRightLogo;
